
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import ChangedateofinstallmentRepository from '@/shared/http/repositories/realestate/changedateofinstallment'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  name: 'FormSearchRequest',
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ
  },
  data () {
    return {
      cliempreend: null,
      SearchItems: {
        empreendimento: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        cliente: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        clienteId: '',
        empreendimentoId: '',
        DataInicio: '',
        DataFinal: ''
      }
    }
  },

  methods: {
    getEmpreendimento () {
      loading.push()
      EnterpriseRepository.GetAll()
        .then(Response => loading.pop())
        .catch(Error => loading.pop())
    },
    getCliente () {
      loading.push()
      usermanagement.GetAll()
        .then(Response => loading.pop())
        .catch(Error => loading.pop())
    },
    onLoad () {
      ChangedateofinstallmentRepository.GetAll()
        .then(Response => {
          this.cliempreend = Response.data.data
        })
        .catch(() => {})
    },
    Clear () {
      localStoreHelper.solicitacoes.alteracaoDataParcela(null)
      this.$refs.EmpreendimentoTypeahead.clear()
      this.$refs.ClienteTypeahead.clear()
      Object.keys(this.SearchItems).forEach(prop => {
        if (prop === 'cliente' || prop === 'empreendimento') {
          this.SearchItems[prop].value = ''
        } else {
          this.SearchItems[prop] = ''
        }
      })
      this.$emit('SearchItems', this.SearchItems, false)
    },
    Search () {
      this.SearchItems.clienteId = this.SearchItems.cliente.value
      var today = new Date()
      if (this.SearchItems.DataInicio !== '' && this.SearchItems.DataFinal === '') {
        this.SearchItems.DataFinal = today
      }
      this.SearchItems.empreendimentoId = this.SearchItems.empreendimento.value
      this.$emit('SearchItems', this.SearchItems, true)
      localStoreHelper.solicitacoes.alteracaoDataParcela(this.SearchItems)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/changedateofinstallment/components/formSearchRequest/formSearchRequest.js